import React from 'react';
import TreeMapChartComponent from '../../../components/Charts/TreeMapChart';

const index = () => {
  return (
    <>
      <div className="home_card_two">
        <div className="">
          <div style={{ marginBottom: '1rem' }}>
            <span className="heading_text">Asset Price Change</span>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '1rem',
            padding: '0px',
          }}
        >
          <TreeMapChartComponent />
        </div>
        <div className="view-assets" style={{ color: '#006DCC' }}>
          Label
        </div>
      </div>
    </>
  );
};

export default index;
